const isCurrentPathEqualsHref = (currentAsPath: string, href: string) => {
  const currentPath = currentAsPath.split('?')[0].split('#')[0]
  return currentPath === href || currentPath === `/en${href}`
}

export default isCurrentPathEqualsHref
